import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import {Loader} from '../../components/widgets/Loader';
import {accountContactPreferences} from '../../actions/account';
import {modalStyles} from '../common/ModalStyles';
import ModalFooter from '../../components/common/ModalFooter';
import CloseIcon from '../../components/common/CloseIcon';
import utils from '../../helpers/utils';

class AlertPrefStatusModal extends Component {

  constructor(props) {
    super(props);
    const selfClose = _get(this.props.propsModal, 'modalProps.data.selfClose', false);
    this.handleClick = this.handleClick.bind(this);
    if (selfClose) {
      setTimeout(() => {
        this.props.dispatch({type: 'HIDE_MODAL'})
      }, 3000);
    }
  }

  componentDidUpdate() {
    const origin = _get(this.props.propsModal, 'modalProps.data.origin', '');
    if (origin === "SMS" && _isEqual(_get(this.props.propAccount, 'status'), 'ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS')) {
      setTimeout(() => {
        this.props.dispatch({type: 'HIDE_MODAL'})
      }, 3000);
    }
  }

  componentWillUnmount() {
    const origin = _get(this.props.propsModal, 'modalProps.data.origin', '');
    let accountId = _get(this.props.auth, 'currentLoggedInUser.accountId');
    let getPrefData = {method: 'get', origin}
    this.props.dispatch(accountContactPreferences(getPrefData, null, accountId));
  }

  handleClick() {
    this.props.dispatch({type: 'HIDE_MODAL'});
  }

  checkModalState() {
    let supType = _get(this.props.propsModal, 'modalType', '');
    if (supType) {
      return true;
    }
    return false;
  }

  checkUpdateStatus() {
    const origin = _get(this.props.propsModal, 'modalProps.data.origin', '');
    if (origin === "SMS" && _isEqual(_get(this.props.propAccount, 'status'), 'ACCOUNT_CONTACT_PREF_UPDATE_REQUEST')) {
      return (
        <div className="ma-loading">
          <Loader/>
        </div>
      )
    }
    return (
      <div>
        <div className="flex flex-col items-center justify-center">
          <img src={utils.getCdnPath("/icon-success.png")} alt="Success" width="200px"/>
          <p className="text-xl md:text-2xl mt-4 text-center">{_get(this.props.propsModal, 'modalProps.data.message')}</p>
        </div>
      </div>
    )
  }

  render() {
    return (
      <Modal
        isOpen={this.checkModalState()}
        style={modalStyles}
        contentLabel="Status"
        onRequestClose={this.handleClick}
      >

        <div>
          <div className="flex h-20 px-6 w-full items-center justify-between border-b border-grey-lightest">
            <p className="w-3/4 text-xl md:text-2xl lg:text-3xl font-bold uppercase">{_get(this.props.propsModal, 'modalProps.data.header')}</p>
            {this.needsManualClose ?
              <div className="ma-modal-close flex w-1/4 justify-end" onClick={this.handleClick}>
                <CloseIcon/>
              </div> : ''}
          </div>
          <div className="flex m-17 justify-center">
            {this.checkUpdateStatus()}
          </div>
          <div className="w-full border-t border-grey-lightest">
            <ModalFooter/>
          </div>

        </div>
      </Modal>
    );
  }

}

AlertPrefStatusModal.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  propsModal: PropTypes.object,
  propAccount: PropTypes.object
};

function mapStateToProps(state) {
  const {modal, account, auth} = state;
  return {propsModal: modal, propAccount: account, auth};
}

export default connect(mapStateToProps)(AlertPrefStatusModal);



// WEBPACK FOOTER //
// ./src/containers/monitoring/AlertPrefStatusModal.js